import React from 'react';

const Iframe = () => {
  return (
<iframe title="Mapso Blog" src="https://cascadr.co/blogs/cozykev" className="iframe" width="100%" height="100%" position="relative" overflow= "hidden" allowFullScreen></iframe>
)
}

export default Iframe